<template>
	<div class="tab-pane-container" :style="paneStyle">
		<div class="tab-pane-header">
			<div class="tab-pane-navs">
				<div
					v-for="(item, index) in tabs"
					:key="getTabValue(item, index)"
					:class="['tab-pane-item', { active: value === getTabValue(item, index), disabled: item.disabled }]"
					@click="handleTabClick(item, index)"
				>
					{{ item.name || item.label }}
					<span v-if="item.badge !== undefined && item.badge !== null" class="tab-pane-item-badge">
						{{ item.badge }}
					</span>
				</div>
			</div>
			<div v-if="$slots.extra" class="tab-pane-extra">
				<slot name="extra"></slot>
			</div>
		</div>
		<div class="tab-pane-content">
			<slot :active-tab="value"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TabPane',
		props: {
			value: {
				type: [String, Number],
				required: true
			},
			tabs: {
				type: Array,
				required: true
			},
			// 支持页面通过 CSS 变量调整组件内部样式，不受 scoped 隔离影响
			paneStyle: {
				type: Object,
				default() {
					return {}
				}
			}
		},
		methods: {
			getTabValue(item, index) {
				return item.value === undefined ? index : item.value
			},
			handleTabClick(item, index) {
				if (item.disabled) {
					return
				}
				const value = this.getTabValue(item, index)
				if (value !== this.value) {
					this.$emit('input', value)
					this.$emit('change', value, item)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';

	.tab-pane-extra {
		position: relative;
		z-index: 1;
	}

	.tab-pane-item.disabled {
		cursor: not-allowed !important;
		opacity: 0.5;
	}
</style>
